import { styled } from '@mui/system';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import RadioGroup from '@mui/material/RadioGroup';
import IconButton from '@mui/material/IconButton';

export const ReportDialogPaper = {
  width: '50%',
  '@media (max-width: 900px)': {
    width: '90%'
  }
};

export const ReportDialogIcon = styled(IconButton)(({ theme }) => ({
  padding: 0,
  color: theme.palette.getContrastText(theme.palette.secondary.main)
}));

export const ReportDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  color: theme.palette.getContrastText(theme.palette.secondary.main),
  backgroundColor: theme.palette.secondary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

export const ReportDialogContent = styled(MuiDialogContent)(({ theme }) => ({
  display: 'grid',
  gridGap: theme.spacing(1),
  gridTemplateColumns: '1fr 2fr',
  padding: theme.spacing(3),
  '& > h6': {
    marginTop: theme.spacing(1) * 0.75
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'auto'
  }
}));

export const ReportRadioGroup = styled(RadioGroup)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column'
  }
}));
